import { FETCH_QUERIES_NAME, MUTATION_KEYS } from '@common/constants';
import { AxiosErrorResponse } from '@core/error.models';
import { IItemResponse, IPagedResultsV1 } from '@gcl/react-core';
import { useMutation, useQuery } from '@tanstack/react-query';
import { IUpdateUserProfilePreferenceRequest, IUserProfilePreferences } from './userProfilePreferences.models';
import { getUserProfilePreferencesAsync, updateProjectTransmittalAsync } from './userProfilePreferences.services';

export const useFetchUserPreferences = (enabled = true) => {
  return useQuery<IPagedResultsV1<IUserProfilePreferences>, AxiosErrorResponse>(
    [FETCH_QUERIES_NAME.USER_PROFILE_PREFERENCES],
    async () => {
      const results = await getUserProfilePreferencesAsync();
      return results;
    },
    {
      enabled,
    },
  );
};

export const useUpdateUserPreferences = () => {
  return useMutation<IItemResponse<IUserProfilePreferences>, AxiosErrorResponse, IUpdateUserProfilePreferenceRequest>(
    [MUTATION_KEYS.UPDATE_USER_PROFILE_PREFERENCES],
    async (request: IUpdateUserProfilePreferenceRequest) => {
      const result = await updateProjectTransmittalAsync(request);
      return result;
    },
  );
};
